module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "score"
    }
  }, [_c('div', {
    staticClass: "column"
  }, [_c('span', {
    attrs: {
      "title": ""
    }
  }, [_vm._v("Score")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.score ? _vm.score.toFixed(2) : 0))])]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    attrs: {
      "title": ""
    }
  }, [_vm._v("Health")]), _vm._v(" "), _c('div', {
    class: ['health', _vm.health]
  })]), _vm._v(" "), _c('div', {
    staticClass: "column"
  }, [_c('span', {
    attrs: {
      "title": ""
    }
  }, [_vm._v("Points per Day")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.pointsPerDay ? _vm.pointsPerDay.toFixed(2) : 0))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fda25fd4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sprint/SprintScore.vue
// module id = 551
// module chunks = 1